import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SharePopup from "../components/SharePopup";
import { db } from "../util/firebaseApp";
import { doc, setDoc, collection } from "firebase/firestore";
import axios from "axios";
import waIcon from "../assets/images/wa-icon.png";

const BookCollection = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const [formStatus, setFormStatus] = useState("Start My Campaign");
  const form = useRef();
  const [bank, setBank] = useState();
  const [sharePopupActive, setSharePopup] = useState(false);
  const [searchParams] = useSearchParams();
  const [bankId, setBankId] = useState("");
  const [shareActive, setShareState] = useState(false);
  const [campaignId, setCampaignId] = useState("");
  const [collectAddress, setAddress] = useState("");
  const [collectName, setName] = useState("");
  const [dropSelected, setDropSelected] = useState(false);

  useEffect(() => {
    setBankId(
      searchParams.get("bankId")
        ? searchParams.get("bankId")
        : "yewkids-nursery"
    );
    console.log("API URL " + apiUrl);
  }, []);

  useEffect(() => {
    getBankInfo();
  }, [bankId]);

  const getBankInfo = async () => {
    console.log("Getting Bank Info");
    if (!bank) {
      console.log("Request to: " + `${apiUrl}/bank/${bankId}`);
      axios
        .get(`${apiUrl}/bank/${bankId}`)
        .then((res) => {
          console.log("Found Bank: " + res.data.name);
          setBank(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setFormStatus("Submitting...");
    const { name, email, phone, address, date, notes, isdropoff, invitee } =
      e.target.elements;
    let collectionForm = {
      name: name.value,
      email: email.value,
      phone: phone.value,
      bankId: bankId,
      address: address.value,
      date: date.value,
      notes: notes.value,
      isdropoff: isdropoff.value,
      invitee: invitee.value,
    };
    console.log(collectionForm);
    setAddress(address.value);
    setName(name.value);

    //const newCollection = doc(collection(db, "collectionCampaigns"));
    //await setDoc(newCollection, collectionForm);

    incrementShareCount();

    axios
      .post(`${apiUrl}/collectionrequest/submit-request `, collectionForm)
      .then((response) => {
        console.log(response);
        setCampaignId(response.data.request_id);
        setShareState(true);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error);
        }
        console.log(error);
        alert("Submission failed, please try again");
      });
  };

  const incrementShareCount = async () => {
    console.log("Increasing share count.");
    console.log(bank);
    var request = `${apiUrl}/bank/inc-share/${
      bank["bankId"] ? bank["bankId"] : bank.id
    }`;

    axios
      .get(request)
      .then((response) => {
        console.log(response);
        setShareState(true);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error);
        }
        console.log(error);
        //alert("Share count update failed, please try again");
      });
  };

  return (
    <PageContainer>
      {sharePopupActive ? <SharePopup exitFunction={setSharePopup} /> : ""}
      <Header />
      <PageContent>
        <Columns>
          <LeftColumn>
            <Swirl src={require("../assets/images/hero-swirl.svg").default} />
            <Title>Launch Your Own Fundraising Campaign</Title>
            <Subtitle>
              Gather a group of at least 10 people to support{" "}
              {bank ? bank.name : "Fundraise & Recycle"}. We’ll collect your
              donated clothes - it’s easy and impactful.
            </Subtitle>
            <Subtitle>
              Sign up below to get started! Once you register, we’ll contact you
              to arrange your collection.
            </Subtitle>
          </LeftColumn>
          <RightColumn>
            {!shareActive ? (
              <Form
                ref={form}
                onSubmit={onSubmit}
                className="sponsor-form"
                noValidate
              >
                <fieldset className="type-toggle">
                  <legend>Campaign Type:</legend>
                  <div className="toggle">
                    <input
                      type="radio"
                      className="form-control"
                      name="isdropoff"
                      id="collection-radio"
                      value="collection"
                      checked
                    />
                    <label
                      for="collection-radio"
                      onClick={() => setDropSelected(false)}
                    >
                      Collection
                    </label>
                    <input
                      type="radio"
                      className="form-control"
                      name="isdropoff"
                      id="drop-radio"
                      value="drop"
                    />
                    <label
                      for="drop-radio"
                      onClick={() => setDropSelected(true)}
                    >
                      Drop-Off
                    </label>
                  </div>
                </fieldset>
                <div className="form-field-container vertical">
                  <label className="form-label" htmlFor="name">
                    Full Name
                  </label>
                  <input
                    className="form-control"
                    name="name"
                    type="text"
                    id="name"
                    placeholder="e.g. Sarah Johnson"
                    required
                  />
                </div>
                <div className="form-field-container vertical">
                  <label className="form-label" htmlFor="email">
                    Email Address
                  </label>
                  <input
                    className="form-control"
                    name="email"
                    type="text"
                    id="email"
                    placeholder="e.g. SarahJohnson@gmail.com"
                    required
                  />
                </div>
                <div className="form-field-container vertical">
                  <label className="form-label" htmlFor="phone">
                    Contact Number
                  </label>
                  <input
                    className="form-control"
                    name="phone"
                    type="text"
                    id="phone"
                    placeholder="e.g. +44 7123 456789"
                    required
                  />
                </div>
                <div className="form-field-container vertical">
                  {dropSelected ? (
                    <label className="form-label" htmlFor="address">
                      Drop-Off Address
                    </label>
                  ) : (
                    <label className="form-label" htmlFor="address">
                      Collection Address
                    </label>
                  )}
                  <input
                    className="form-control"
                    name="address"
                    id="address"
                    placeholder="Door Number, Street, Post Code"
                  />
                </div>
                <div className="form-field-container vertical">
                  <label className="form-label" htmlFor="notes">
                    Notes
                  </label>
                  <input
                    className="form-control"
                    name="notes"
                    id="notes"
                    placeholder="Any note you might have for campaigners you invite"
                  />
                </div>
                <div className="form-field-container vertical">
                  <label className="form-label" htmlFor="date">
                    Fundraiser End Date
                  </label>
                  <input
                    className="form-control"
                    name="date"
                    type="date"
                    id="date"
                  />
                </div>
                <DarkSubtitle>Invite others to join this campaign:</DarkSubtitle>
                <div className="form-field-container">
                  <label className="form-label" htmlFor="invitee">
                    Separate email addresses with spaces or commas
                  </label>
                  <input
                    className="form-control"
                    name="email"
                    type="text"
                    id={`invitee`}
                    placeholder="e.g. SarahJohnson@gmail.com"
                    required
                  />
                </div>
                <div className="form-field-container checkbox wa">
                  <label className="form-label" htmlFor="wa-button">
                    Need help? Chat with us on Whatsapp
                  </label>
                  <a
                    href="https://wa.me/447453958291"
                    target="_blank"
                    className="form-control"
                    type="checkbox"
                    id="wa-button"
                  >
                    <img src={waIcon} alt="WhatsApp Button" />
                  </a>
                </div>
                <div className="form-field-container checkbox">
                  <label className="form-label" htmlFor="mailTick">
                    {" "}
                    Keep me updated with collection progress and fundraising
                    tips
                  </label>
                  <input
                    className="form-control"
                    type="checkbox"
                    id="mailTick"
                    defaultChecked
                  />
                </div>
                <button className="btn btn-danger" type="submit">
                  {formStatus}
                </button>
              </Form>
            ) : (
              <PostFormContent>
                <ol>
                  <li>It’s time to share your fundraising campaign! </li>
                  <li>⁠Click the share my campaign button. </li>
                  <li>
                    ⁠Line up 10 or more keen recyclers looking to clear out
                    their wardrobes.
                  </li>
                  <li>
                    ⁠Invite them to join your fundraising campaign and support
                    your organisation.{" "}
                  </li>
                  <li>
                    ⁠Spread awareness and knowledge of your fundraising and
                    recycling campaign.{" "}
                  </li>
                  <li>
                    ⁠Watch the momentum build as you receive their acceptance
                    emails.
                  </li>
                </ol>
                <>
                  <div className="form-field-container checkbox wa">
                    <label className="form-label" htmlFor="wa-button">
                      Need help? Chat with us on Whatsapp
                    </label>
                    <a
                      href="https://wa.me/447453958291"
                      target="_blank"
                      className="form-control"
                      type="checkbox"
                      id="wa-button"
                    >
                      <img src={waIcon} alt="WhatsApp Button" />
                    </a>
                  </div>
                  <ShareDirectText>
                    Share this link directly with everyone you want to join your
                    campaign:
                  </ShareDirectText>
                  <ShareDirectText>
                    <a
                      href={`https://online.fundraiserecycle.com/bank?bankId=${bankId}&campaignid=${campaignId}`}
                    >{`https://online.fundraiserecycle.com/bank?bankId=${bankId}&campaignid=${campaignId}`}</a>
                  </ShareDirectText>
                  <ShareButton
                    className="cta-3"
                    onClick={() => {
                      if (navigator.share) {
                        navigator
                          .share({
                            title: window.title,
                            text: `Hi,\n\nI’m inviting you to support ${
                              bank ? bank.name : "this organisation"
                            } by clearing out your wardrobe!\n\nThey’re running a fundraising campaign by recycling unwanted clothes—and we can all make a difference. 💼👗👟👜🎁✨\n\nSimply gather clothes, shoes, handbags, gift sets, or jewelry you no longer need and drop them off at:\n\n👉 ${collectAddress}\n\nPlease share this with as many friends and family as you want! Thank you so much!\n\nWarm regards,\n${collectName}`,
                            url: `/bank?bankId=${bankId}&campaignid=${campaignId}`,
                          })
                          .then(() => {
                            console.log("Successful share");
                            incrementShareCount();
                          })
                          .catch((error) =>
                            console.log("Error sharing", error)
                          );
                      } else {
                        incrementShareCount();
                        setSharePopup(true);
                      }
                    }}
                  >
                    <p>Share My Campaign</p>
                  </ShareButton>
                </>
              </PostFormContent>
            )}
          </RightColumn>
        </Columns>
      </PageContent>
      <Footer />
    </PageContainer>
  );
};

export default BookCollection;

const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 1060px) {
    background: #f8fdff;
  }
`;

const Columns = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  padding: 20px;
  gap: 20px;
  max-width: 700px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 1080px) {
    flex-direction: column;
  }
`;

const LeftColumn = styled.div`
  width: 100%;
  background: #0f678f;
  overflow: hidden;
  border-radius: 30px;
  padding: 30px 30px 50px 50px;
  position: relative;
  min-height: 400px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1080px) {
    max-width: 100%;
  }

  @media (max-width: 530px) {
    padding: 20px;
  }
`;

const RightColumn = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 1080px) {
    max-width: 100%;
    align-items: center;
  }
`;

const PageContent = styled.div`
  max-width: 1296px;
  width: 100%;
  min-height: 68vh;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  ol {
    margin: 0;
    padding: 0 0 0 20px;
  }

  ol li {
    font-size: 24px;
    line-height: 28px;
    color: #004a71;
    margin: 20px 0;
  }

  .form-field-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    margin-top: 12px;
  }

  .form-field-container.horizontal {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    label {
      margin: 0;
    }
  }

  input,
  textarea,
  select {
    box-sizing: border-box;
    width: 100%;
    padding: 12px;
    outline: 0;
    border: 0;
  }

  input,
  textarea {
    background: white;
    border-radius: 12px;
    border: 1px solid #004a71;
  }

  textarea::placeholder,
  input::placeholder {
    color: #75b3ce;
  }

  #adPhoto {
    padding: 0;
  }

  label,
  legend {
    color: #004a71;
    margin-bottom: 8px;
    font-size: 18px;
    box-sizing: border-box;
  }

  button {
    border: 0;
    padding: 18px 24px;
    border-radius: 30px;
    font-size: 22px;
    background: #ef3e3c;
    width: 100%;
    color: white;
    margin-top: 24px;
  }

  .form-field-container.checkbox {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .form-field-container.checkbox label {
    order: 2;
    font-size: 18px;
    margin-left: 10px;
  }

  .form-field-container.checkbox input {
    order: 1;
  }

  #mailTick {
    appearance: none; /* Remove default checkbox styling */
    -webkit-appearance: none; /* Safari */
    -moz-appearance: none; /* Firefox */
    width: 28px;
    height: 28px;
    position: relative;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #mailTick:checked {
    background: #004a71;
  }

  #mailTick:checked::after {
    content: "✔";
    color: white;
    font-size: 16px;
    font-weight: normal;
  }

  .radio-block {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
  }

  .radio-block input {
    width: min-content;
    margin-right: 20px;
    margin-top: 6px;
  }

  fieldset {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border: 0;
    padding: 0;
    margin: 0;
    legend {
      padding: 0;
      float: left;
    }
    input {
      display: none;
    }
  }

  .toggle {
    box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: stretch;

    input + label {
      margin: 0;
      padding: 8px 30px;
      border: solid 1px #004a71;
      background-color: #fff;
      font-size: 1rem;
      line-height: 140%;
      text-align: center;
      box-shadow: 0 0 0 rgba(255, 255, 255, 0);
      transition: border-color 0.15s ease-out, color 0.25s ease-out,
        background-color 0.15s ease-out, box-shadow 0.15s ease-out;

      &:first-of-type {
        border-radius: 12px 0 0 12px;
        border-right: none;
      }
      &:last-of-type {
        border-radius: 0 12px 12px 0;
        border-left: none;
      }
    }

    input:hover + label {
      border-color: #004a71;
    }

    input:checked + label {
      background-color: #004a71;
      color: #fff;
      box-shadow: $activeShadow;
      border-color: #004a71;
      z-index: 1;
    }
  }

  @media (max-width: 500px) {
    .type-toggle {
      flex-direction: column;
    }
  }

  #wa-button {
    line-height: 0;
    margin: 0px 3px 6px 4px;
    cursor: pointer;
  }

  #wa-button img {
    width: 28px;
    height: 28px;
  }

  .wa {
    margin-top: 48px;
  }

  #wa-button {
    line-height: 0;
    margin: 0px 3px 6px 4px;
    cursor: pointer;
  }

  #wa-button img {
    width: 28px;
    height: 28px;
  }

  .wa {
    margin-top: 48px;
  }
`;

const Title = styled.h1`
  font-size: 48px;
  font-weight: bold;
  color: white;
  margin: 0;
  z-index: 5;

  @media (max-width: 530px) {
    font-size: 36px;
  }
`;

const Subtitle = styled.h2`
  color: white;
  margin-bottom: 0;
  font-weight: normal;
  z-index: 5;
  font-size: 32px;

  @media (max-width: 530px) {
    font-size: 24px;
  }
`;

const DarkSubtitle = styled.h2`
  color: rgb(0, 74, 113);
  margin-bottom: 0;
  font-weight: normal;
  z-index: 5;
  font-size: 32px;

  @media (max-width: 530px) {
    font-size: 24px;
  }
`

const Paragraph = styled.p``;

const Form = styled.form`
  box-sizing: border-box;
  max-width: 470px;
  width: 100%;
  padding: 0 24px 24px 24px;
  margin: 0 auto;
`;

const ShareButton = styled.a`
  width: 100%;
  margin-top: 20px;
  background: #ef3e3c;
  color: white;
  text-align: center;
  box-sizing: border-box;

  border: 0;
  padding: 18px 24px;
  border-radius: 30px;
  font-size: 22px;
  background: #ef3e3c;
  width: 100%;
  color: white;
  margin-top: 24px;

  border-radius: 50px;

  p {
    margin: 0;
    color: white;
    font-weight: bold;
    font-weight: normal;
  }

  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const Swirl = styled.img`
  position: absolute;
  width: 150%;
  transform: rotateZ(-90deg);
  right: -30%;
  bottom: 100px;

  @media (max-width: 1080px) {
    min-width: 100%;
    min-height: 100%;
    object-fit: cover;
    left: -10%;
    top: 10%;
  }
`;

const ShareDirectText = styled.p`
  margin-bottom: 0;
  font-size: 22px;
  display: none;
`;

const PostFormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 80%;
  margin: 0 auto;

  .wa {
    margin-top: 12px;
  }

  .wa.checkbox.form-field-container label {
    font-size: 24px;
  }
`;
